import React, {useContext} from "react";

import { Headline } from "../../../components/Headline";

import CameraFilterContext from "../CameraListing/CameraFilterContext";

import t from "../../../lib/translate";

import * as styles from "./resultcount.module.less";

export function ResultCount() {
    const { resultCount } = useContext(CameraFilterContext);

    return (
        <Headline semanticOfHeadline="H4"
                  hasLightBackground
                  headlineClass={styles.animatedCounter}
        >
            {t("camera.filter.resultcount", [resultCount])}
        </Headline>
    );
}
